import type { ReactNode } from 'react'
import { config } from '@/config/env'

interface Styles {
  readonly bg: string
  readonly text: string
  readonly dot: string
}

function resolveStyles(label: string): Styles {
  if (label.startsWith('Produktion')) {
    return {
      bg: 'bg-red-100 dark:bg-red-950',
      text: 'text-red-800 dark:text-red-100',
      dot: 'bg-red-500',
    }
  }
  if (label.startsWith('Staging')) {
    return {
      bg: 'bg-amber-100 dark:bg-amber-950',
      text: 'text-amber-800 dark:text-amber-100',
      dot: 'bg-amber-500',
    }
  }
  return {
    bg: 'bg-blue-100 dark:bg-blue-950',
    text: 'text-blue-800 dark:text-blue-100',
    dot: 'bg-blue-500',
  }
}

/**
 * Zeigt dauerhaft, gegen welches Backend die App läuft.
 *
 * Produktion = rot, Staging = gelb, Entwicklung = blau. Der Punkt
 * blinkt nicht, er pulsiert nicht, er ist einfach nur ein Indikator.
 * Die URL steht im Tooltip.
 */
export function ApiEnvironmentBadge(): ReactNode {
  const styles = resolveStyles(config.apiTargetLabel)

  return (
    <span
      title={config.apiTargetUrl}
      className={`inline-flex items-center gap-1.5 rounded-full px-2.5 py-0.5 text-xs font-medium ${styles.bg} ${styles.text}`}
    >
      <span className={`inline-block h-1.5 w-1.5 rounded-full ${styles.dot}`} />
      {config.apiTargetLabel}
    </span>
  )
}
